import { Link } from "react-router-dom";
import HomeFeatures from "./HomeFeatures";
import HomeMain from "./HomeMain";
import MenuIcon from "../../Assets/Icons/restaurant.png";
import HomeReviews from "./HomeReviews";
import HomeInfo from "./HomeInfo";
import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="home-page">
      <HomeMain />
      <HomeInfo />
      <HomeFeatures />
      <HomeReviews />
      <Link className="home-menu-btn" to="/meni">
        <img src={MenuIcon} alt="ikonica za meni" /> MENU
      </Link>
    </div>
  );
}
